import React from 'react';

interface CardIconProps {
  className?: string;
  size?: number;
}

export const CardIcon: React.FC<CardIconProps> = ({ className = '', size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Landscape card rectangle */}
    <rect x="2" y="5" width="20" height="14" rx="2" />
    {/* Letter C */}
    <path d="M15 9.5a3.5 3.5 0 1 0 0 5" />
  </svg>
);
